import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    return (
        <div className="relative group">
            <button className="flex items-center gap-1 p-1.5 rounded-lg hover:bg-white/10 transition-colors">
                <span className="text-xl">{i18n.language === 'en' ? '🇬🇧' : i18n.language === 'fr' ? '🇫🇷' : i18n.language === 'de' ? '🇩🇪' : '🇳🇱'}</span>
                <span className="material-symbols-outlined text-white text-xl">expand_more</span>
            </button>
            <div className="absolute right-0 top-full mt-2 w-40 bg-white rounded-lg shadow-xl py-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 transform origin-top-right">
                <button onClick={() => i18n.changeLanguage('en')} className="w-full px-4 py-2 text-left hover:bg-brand-beige flex items-center gap-3">
                    <span className="text-xl">🇬🇧</span>
                    <span className="text-brand-deep-green font-medium">English</span>
                </button>
                <button onClick={() => i18n.changeLanguage('fr')} className="w-full px-4 py-2 text-left hover:bg-brand-beige flex items-center gap-3">
                    <span className="text-xl">🇫🇷</span>
                    <span className="text-brand-deep-green font-medium">Français</span>
                </button>
                <button onClick={() => i18n.changeLanguage('de')} className="w-full px-4 py-2 text-left hover:bg-brand-beige flex items-center gap-3">
                    <span className="text-xl">🇩🇪</span>
                    <span className="text-brand-deep-green font-medium">Deutsch</span>
                </button>
                <button onClick={() => i18n.changeLanguage('nl')} className="w-full px-4 py-2 text-left hover:bg-brand-beige flex items-center gap-3">
                    <span className="text-xl">🇳🇱</span>
                    <span className="text-brand-deep-green font-medium">Nederlands</span>
                </button>
            </div>
        </div>
    );
};

export default LanguageSwitcher;
